// Share-link mobile sheet (Figma "Track Link - V3 (Tabs layout)") — flat bordered cards inside the
// tabbed bottom sheet. Only applied when a section receives `isShareMobile`, so the in-app Track
// page and the desktop share overlay keep their own look.
export const SHARE_MOBILE_CARD = 'w-full bg-white border border-utilityGray200 rounded-lg shadow-xs';
export const SHARE_MOBILE_CARD_TITLE = 'text-xs leading-[18px] font-medium text-grayLight900';

// CardCmp-based sections: reshape its header row to the Figma card title (12/18 medium, 8px padding).
export const SHARE_MOBILE_CARDCMP = {
    cardClassName: '!rounded-lg !border !border-utilityGray200 !shadow-xs',
    headerParentClassName: '!border-b-0 !min-h-0 !px-2 !pt-2 !pb-1 [&_.table-title]:!text-xs [&_.table-title]:!leading-[18px] [&_.table-title]:!font-medium [&_.table-title]:!text-grayLight900',
    // Figma: title row pb-4 + card gap 8 → 12px from the title to the first row (header gives 4px).
    childrenClassName: '!px-2 !pt-2 !pb-2',
};

// Detail rows: label 12/18 regular, value 12/18 medium — both text-tertiary (#475467).
export const SHARE_MOBILE_ROW_TEXT = '!text-grayLight600';
